/* ==================================================
 * Modernizr
 * https://modernizr.com/docs
 * ==================================================*/

(function () {

  'use strict';

  // if (!Modernizr.objectfit) {
  //   $('[data-srcset]').each(function () {
  //     var $this = $(this);
  //     var url = $this.attr('data-srcset', '').attr('data-fallback');

  //     if (url) {
  //       $this.css('backgroundImage', 'url(' + url + ')');
  //     }
  //   });
  // }
})();
